const controller = ($scope, $timeout, baseNotificationService, $sce) => {
  const vm = $scope
  vm.lastNotificationId = null
  vm.notificationsNews = []
  vm.notificationsOlds = []
  vm.total = 0
  vm.totalDisplay = 0

  vm.clearAllNoticationsOlds = () => {
    for (const notification of vm.notificationsOlds) {
      notification.onClick(notification, 'all', true)
      break
    }
  }

  const separatorNotications = (notifications = []) => {
    vm.totalDisplay = notifications.length
    vm.total = baseNotificationService.total
    vm.lastNotificationId = notifications[notifications.length-1] ? notifications[notifications.length-1].id : null
    vm.notificationsNews = notifications.filter((n) => !n.read)
    vm.notificationsOlds = notifications.filter((n) => n.read)
    if (vm.notificationsNews.length > 0 || vm.notificationsOlds.length > 0) {
      $timeout(() => {
        vm.notifications = []
        if (vm.notificationsNews.length > 0) {
          vm.notifications.push({
            label: 'Novas',
            active: false,
            items: vm.notificationsNews
          })
        }
        if (vm.notificationsOlds.length > 0) {
          vm.notifications.push({
            label: `Anteriores`,
            active: true,
            items: vm.notificationsOlds
          })
        }
      })
    }
  }

  vm.getWidth = (size) => {
    return  (23 + (size.toString().length * 4)) + 'px'
  }

  vm.getRight = (size) => {
    return size.toString().length * -3
  }

  separatorNotications(baseNotificationService.notifications)

  baseNotificationService.onNotificationChange((notifications) => {
    $timeout(() => {
      separatorNotications(notifications)
    })
  })

  const onClickOutside = () => {
    $timeout(() => {
      vm.notificationOpen = false
      $timeout(() => document.removeEventListener('dblclick', onClickOutside))
    })
  }

  vm.trustAsHtml = function (string) {
    return $sce.trustAsHtml(string)
  }

  vm.toogle = () => {
    vm.notificationOpen = !vm.notificationOpen
    if (vm.notificationOpen) {
      $timeout(() => document.addEventListener('dblclick', onClickOutside))
    } else {
      $timeout(() => document.removeEventListener('dblclick', onClickOutside))
    }
  }

  vm.handleClickNotification = (evt, notification, action) => {
    if (notification.actions && notification.actions.length > 0) {
      evt.preventDefault()
      evt.stopPropagation()
      if (action) {
        onClickOutside()
        notification.onClick(notification, action)
      }
    } else {
      if (notification.onClick) {
        notification.onClick(notification, action)
      }
    }
  }

  vm.removeNotification = (notification) => {
    notification.onClick(notification, undefined, true)
  }

  vm.seeMore = () => {
    baseNotificationService.seeMoreFunction(vm.lastNotificationId)
  }

  vm.openSetting = () => {
    baseNotificationService.openSetting()
  }

};

export default controller;



// WEBPACK FOOTER //
// ./src/modules/topbar/components/notifications/notifications.controller.js